import React from "react";

const ACHIEVEMENTS = [
  { icon: "fa fa-trophy", text: "Hackathon Winner — Rank 1 / 200+" },
  { icon: "fa fa-bolt", text: "Tech-A-Thon Winner 2023 — 500+ Devs" },
  { icon: "fa fa-flag", text: "Smart India Hackathon — Top 10,000+" },
  { icon: "fa fa-globe", text: "Google Hash Code — Rank 2,740 / 50K+" },
  { icon: "fa fa-shield", text: "Microsoft Certified — Score 860/1000" },
  { icon: "fa fa-code", text: "Codeforces Specialist 1431" },
  { icon: "fa fa-star", text: "CodeChef 3-Star — Rating 1866" },
  { icon: "fa fa-terminal", text: "LeetCode Rating 1821" },
];

const AchievementRow = ({ reverse }) => (
  <div className={`achievement-track ${reverse ? "achievement-reverse" : ""}`}>
    {[...ACHIEVEMENTS, ...ACHIEVEMENTS].map((item, i) => (
      <span key={i} className="achievement-item">
        <i className={item.icon} />
        <span>{item.text}</span>
        <span className="achievement-separator">◆</span>
      </span>
    ))}
  </div>
);

const AchievementBanner = () => (
  <div className="achievement-banner">
    <AchievementRow />
    <AchievementRow reverse />
  </div>
);

export default AchievementBanner;
